import { ScdType } from "./ScdSelectorTypes";

export function ConvertScdTypeToHiddenId(scdType: string) {
    return scdType == "sct" ? "Sectors" : scdType == "cou" ? "Countries" : scdType == "don" ? "Donors" : "cci" ;
}

function FireOnChangeEvent(scdType: string)
{
    const event = new Event('scd-change');    
    const element = document.querySelector('.bscList[data-type="' + scdType + '"]');
    element?.dispatchEvent(event);
}

function UpdateCategory(scdType: string, id: string) {
    // seems like I'm never updating this on select alls
    const selectedValuesElement = document.querySelector('#' + ConvertScdTypeToHiddenId(scdType)) as HTMLInputElement;
    const selectedValues = (selectedValuesElement.value ?? "").split(',');
    // rmeoves any dups
    const set = [...new Set(selectedValues)];

    const countElement = document.querySelector(".interest__category-number[data-category-id='" + id + "'][data-scd-type='" + scdType + "']") as HTMLElement;
    const count = set.filter((item) => {
        if (scdType == 'don') {
            // if this is a parent node then don't count it
            const element = document.getElementById(item) as HTMLInputElement;
            if (element === null || element.classList.contains('interest__item-selectall'))
            {
                return;
            }

            if (item.split('-')[1] === id)
            {
                return item;
            }
        }
        else {
            const ids = item.substring(4, item.length).split('-');
            if (ids[0] === id) {
                return item;
            }
        }
    }).length;

    FireOnChangeEvent(scdType);

    if (count == 0) {
        countElement.style.display = "none";
        return;
    }

    countElement.style.display = "inline-block";
    countElement.innerHTML = count.toString();
}

function updateButtonLabel(scdType: string) {
    if ((document.querySelector('.collapseButtonScd[data-type="' + scdType + '"]') as HTMLElement) === null) {
        return;
    }
    const elements = document.querySelectorAll('.collapseButtonScd[data-type="' + scdType + '"] .interest__category-number:not([style="display: none"])') as NodeListOf<HTMLDivElement>;
    
    let counter = 0;
    elements.forEach(node => { 
        counter += parseInt(node.innerText);
    });

    const countElement = document.querySelector('.collapseButtonScd[data-type="' + scdType + '"] .counter-badge') as HTMLDivElement;
    if (counter == 0) {
        countElement.style.display = "none";
        return;
    }

    countElement.style.display = "inline-block";
    countElement.innerText = counter.toString(); 
}

function UpdateCategorySelectAll(isChecked: boolean, scdType: string, categoryId: string) {
    const elements = document.querySelectorAll('.interest__item-input[data-category-id="' + categoryId + '"][data-scd-type="' + scdType + '"]') as NodeListOf<HTMLInputElement>;
    const selectedValuesElement = document.querySelector('#' + ConvertScdTypeToHiddenId(scdType)) as HTMLInputElement;
    const values: string[] = [];
    
    elements.forEach((item) => {
        if (item.disabled)
        {
            return;
        }

        if (!item.checked) {
            values.push(item.id);
        }

        item.checked = isChecked
    });

    let selectedValues: string[] = [];
    const checkedItems = document.querySelectorAll('.interest__item-input[data-scd-type="' + scdType + '"]:checked') as NodeListOf<HTMLInputElement>;
    checkedItems.forEach((item) => { selectedValues.push(item.id);  });
    selectedValuesElement.value = selectedValues.join(',');
    
    UpdateCategory(scdType, categoryId);
}
/** HANDLERS */
function UpdateCategorySelectAllHandler(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    const categoryId = element.dataset.categoryId ?? "";
    const scdType = element?.dataset?.scdType ?? "";

    UpdateCategorySelectAll(element.checked, scdType, categoryId);
    updateButtonLabel(scdType);
}

function UpdateSelectAllHandler(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    const scdType = element?.dataset?.scdType ?? "";

    const categoryAll = document.querySelectorAll('.select-all-cat[data-scd-type="' + scdType + '"]') as NodeListOf<HTMLInputElement>;
    
    categoryAll.forEach((item) => {
        item.checked = element.checked;
        const categoryId = item.dataset.categoryId;
        UpdateCategorySelectAll(element.checked, scdType, categoryId?.toString() ?? "");
    });

    updateButtonLabel(scdType);
}

function UpdateItemHandler(event: Event) {
    const element = event.currentTarget as HTMLInputElement;

    if (element.disabled)
    {
        return;
    }

    const scdType = element?.dataset?.scdType ?? "";
    updateItemList(element, scdType);

    UpdateCategory(element?.dataset?.scdType ?? "", element?.dataset?.categoryId ?? "");
    updateButtonLabel(scdType);
}

export function updateItemList(element: HTMLInputElement, scdType: string) {
    
    const selectedValuesElement = document.querySelector('#' + ConvertScdTypeToHiddenId(scdType)) as HTMLInputElement;
    let selectedValues: string[] = [];

    if (selectedValuesElement.value.length > 0) {
        selectedValues = (selectedValuesElement.value ?? "").split(',');
    }
    
    if (element.checked) {
        selectedValues.push(element.id);
    }
    else {
        selectedValues = selectedValues.filter((item) => {
            if (item !== element.id) return item; 
        })
    }

    selectedValuesElement.value = selectedValues.join(',');
}

export function searchInputHandler(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    const scdType = element?.dataset?.scdType ?? "";
    const scdSection = document.querySelector('.interest-list__wrapper-inner[data-scd-type="' + scdType + '"]'); 
    const text = element.value.toUpperCase();

    scdSection?.querySelectorAll('.interest__item-text').forEach((item) => {
        const itemLabel = item.querySelector('span')?.innerText;
        const parentElement = item.parentElement;
        
        if (text == '' || (itemLabel && itemLabel?.toUpperCase().indexOf(text) > -1)) {
            parentElement!.style.display = 'block';
        }
        else {
            parentElement!.style.display = 'none';
        }
    });

    scdSection?.querySelectorAll('.interest-list__category').forEach((item: HTMLElement) => {
        const selectAllContainer = item.querySelector('.cat-all-select-container') as HTMLElement;
        selectAllContainer.style.display = text != '' ? 'none' : 'block';        

        if (item.querySelectorAll('.interest__item[style*="display: block"]').length > 0) {
            (item.querySelector('.cat-title') as HTMLElement).style.display = 'block';
        }
        else {
            (item.querySelector('.cat-title') as HTMLElement).style.display = 'none';
        }
    });
}

function UpdateParentChildSelectorsHandler(event: Event)
{
    const parent = event.currentTarget as HTMLInputElement;
    const allChild = document.querySelectorAll(`.interest__item-child[data-scd-parent="${parent.id.split('-')[2]}"]`) as NodeListOf<HTMLInputElement>;

    const scdType = parent.dataset.scdType ?? "";

    allChild.forEach(item => {
        item.checked = parent.checked;
        updateItemList(item, scdType);
    });

    UpdateCategory(scdType, parent.dataset.categoryId ?? "");
    updateButtonLabel(scdType);
}

export function InitializeScdHandlers() {
    const selectAllElements = document.querySelectorAll(".select-all");
    const categoryElements = document.querySelectorAll(".select-all-cat");
    const itemElements = document.querySelectorAll(".interest__item-input:not(.interest__item-selectall)");
    const searchElements = document.querySelectorAll('.interest__search');
    const headerElements = document.querySelectorAll(".interest__category-item");
    const parentsWithChildren = document.querySelectorAll(".interest__item-selectall");

    selectAllElements.forEach((item) => {
        item.addEventListener("click", UpdateSelectAllHandler);
    });
    
    categoryElements.forEach((item) => {
        item.addEventListener("click", UpdateCategorySelectAllHandler);
    });
    
    itemElements.forEach((item) => {
        item.addEventListener("click", UpdateItemHandler)
    });
    
    searchElements.forEach((item) => {
        item.addEventListener('input', searchInputHandler);
    });
    
    headerElements.forEach((item) => {
        item.addEventListener("click", (event) => {
            const element = event.currentTarget as HTMLElement;
            const type = element.dataset.scdType;
            const id = element.dataset.categoryId;
            const container = document.querySelector(".interest-list__wrapper-inner[data-scd-type=" + type + "]") as HTMLDivElement;
            const elementTo = document.getElementById(`cat-all-${type}-${id}`) as HTMLElement;
            const offsetValue = 20;
            container.scrollTo({ behavior: 'smooth', top: elementTo.offsetTop - (elementTo.clientHeight + offsetValue)});
        })
    });

    parentsWithChildren.forEach(item => item.addEventListener("click", UpdateParentChildSelectorsHandler));
}

export function UpdateTotalList(event: Event)
{
    const element = event.currentTarget as HTMLDivElement;
    const elements = element.querySelectorAll('.interest__item-input:not(.interest__item-selectall):checked') as NodeListOf<HTMLInputElement>;
    const headerCounter = document.querySelector('.scd-header[data-type="' + element.dataset.type +'"] .counter-badge') as HTMLDivElement;
    
    if (headerCounter){
        headerCounter.innerHTML = elements.length.toString();
    }
}

export function ClearAll(scdType: ScdType) {
    const categoryAll = document.querySelectorAll('.select-all-cat[data-scd-type="' + scdType + '"]') as NodeListOf<HTMLInputElement>;

    categoryAll.forEach((item) => {
        item.checked = false;
        const categoryId = item.dataset.categoryId;
        UpdateCategorySelectAll(false, scdType, categoryId?.toString() ?? "");
    });

    updateButtonLabel(scdType);
}

export function FilterSelection()
{
    const sectorsToDisable = document.getElementById('dta-sectors') as HTMLInputElement;
    const countriesToDisable = document.getElementById('dta-countries') as HTMLInputElement;
    const donorsToDisable = document.getElementById('dta-donors') as HTMLInputElement;
    
    const sectors = document.querySelectorAll('.interest__item-input[data-scd-type="sct"]') as NodeListOf<HTMLInputElement>;
    const countries = document.querySelectorAll('.interest__item-input[data-scd-type="cou"]') as NodeListOf<HTMLInputElement>;
    const donors = document.querySelectorAll('.interest__item-input[data-scd-type="don"]') as NodeListOf<HTMLInputElement>;

    const sm = new Set(sectorsToDisable.value.split(','));
    const cm = new Set(countriesToDisable.value.split(','));
    const dm = new Set(donorsToDisable.value.split(','));

    sectors.forEach(item => { item.disabled = true; if (sm.has(item.id)) { item.disabled = false; } });
    countries.forEach(item => { item.disabled = true; if (cm.has(item.id)) { item.disabled = false; } });
    donors.forEach(item => { item.disabled =  true; if (dm.has(item.id)) { item.disabled = false; } });    
}